import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ChartCard } from '../components/ChartCard';
import { DepartmentCockpit } from '../components/DepartmentCockpit';
import { regionPerformance } from '../lib/mock-data';

export function SalesPage() {
  return (
    <div className="pb-12">
      <DepartmentCockpit
        section="sales"
        pageTitle="Pipeline & Performance"
        pageEyebrow="Sales Dashboard"
        pageDescription="Live CRM extracts feeding pipeline, conversion and territory analytics."
      >
        {() => <SalesCharts />}
      </DepartmentCockpit>
    </div>
  );
}
  

function SalesCharts() {
  const data = regionPerformance;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-2">
      <ChartCard title="Region Performance" subtitle="Actual vs Target (index 100)" className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
            <CartesianGrid stroke="var(--color-border)" vertical={false} />
            <XAxis dataKey="region" stroke="var(--color-muted-foreground)" fontSize={11} tickLine={false} axisLine={false} />
            <YAxis stroke="var(--color-muted-foreground)" fontSize={11} tickLine={false} axisLine={false} />
            <Tooltip contentStyle={{ background:"var(--color-popover)", border:"1px solid var(--color-border)", borderRadius:8, fontSize:12 }} cursor={{ fill:"var(--color-border)" }} />
            <Bar dataKey="target" fill="var(--color-border)" radius={[4, 4, 0, 0]} />
            <Bar dataKey="actual" fill="oklch(0.78 0.18 195)" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </ChartCard>
    </div>
  );
}
